import * as React from "react";
import { Form } from "semantic-ui-react";
import * as _ from "lodash";
import MenuButton from "../MenuButton/MenuButton";

export type ButtonProps = {
  callback: () => void;
  enabledTooltip?: string;
  disabledTooltip?: string;
  disabled?: boolean;
};

export type ActionEditorProps<T> = {
  itemName: string;
  originalObject: T;
  editedObject: T;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any;
  hasWritePermission: boolean;
  isValid: boolean;
  cancel: () => void;
  update: () => void;
  create: () => void;
  copy?: () => void;
  remove?: ButtonProps;
};

function ActionEditor<T>({
  itemName,
  originalObject,
  editedObject,
  children,
  hasWritePermission,
  isValid,
  cancel,
  update,
  create
}: ActionEditorProps<T>): JSX.Element {
  const hasParameterEdited = !_.isEqual(editedObject, originalObject);
  const isNew = !originalObject;
  return (
    <>
      <div className="io-action-editor-header">
        <span>
          {hasWritePermission ? "Edit" : "View"} {itemName}
        </span>
        
        <div className="io-action-editor-header-actions">
        {(hasParameterEdited && !isNew) && <span className="edit-notification">You have unsaved changes!</span>}
          {!isNew ? (
            <MenuButton
              type="Save"
              handleOnClick={update}
              disabled={!hasWritePermission || !hasParameterEdited || !isValid}
            />
          ) : (
            <MenuButton
              type="Save"
              handleOnClick={create}
              disabled={!hasWritePermission || !hasParameterEdited || !isValid}
            />
          )}

          {hasParameterEdited ? (
            <MenuButton type="Cancel" handleOnClick={cancel} />
          ) : (
            <MenuButton type="Close" handleOnClick={cancel} />
          )}
        </div>
      </div>

      <div className="io-action-editor-form">
        <Form>{children}</Form>
      </div>
    </>
  );
}

export default ActionEditor;
